import apiClient from "src/config/apiClient";
import { getTemplateGeneratorBaseUrl } from "src/config/endpoints";
import { getAuthToken } from "./httpUtils";
import { normalizeApiLang, type ApiLang } from "src/utils/apiLang";

const TEMPLATE_GENERATOR_BASE_URL = getTemplateGeneratorBaseUrl();

interface CampaignPayload {
  tenant_id: number;
  campaign_name: string;
  send_to: string[];
  dont_send_to?: string[];
  html: string;
  send_at: string;
  company_name_engagements?: string;
  lang?: ApiLang;
}

export const sendCampaignEmail = async (payload: Omit<CampaignPayload, "tenant_id">) => {
  try {
    const apiKey = getAuthToken("api_key");
    const tenantId = localStorage.getItem("tenant_id");

    if (!tenantId) {throw new Error("Tenant ID not found in localStorage");}
    if (!payload.html?.trim()) {throw new Error("Campaign HTML is required");}

    const lang = normalizeApiLang(payload.lang);
    const finalPayload: CampaignPayload = {
      ...payload,
      tenant_id: Number(tenantId),
      lang,
      company_name_engagements:
        payload.company_name_engagements ??
        localStorage.getItem("company_name_engagements") ??
        localStorage.getItem("company_name") ??
        undefined,
    };

    const url = `${TEMPLATE_GENERATOR_BASE_URL}/send-campaign-email?lang=${lang}&api_key=${apiKey}`;
    const res = await apiClient.post(url, finalPayload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return res.data;
  } catch (err: unknown) {
    const error = err as { response?: { data?: unknown }; message?: string };
    throw error.response?.data || error.message;
  }
};
